// Shashank's 90-Day Fat-Loss & Muscle Plan (PDF v6) has two daily menus -
// "alternate them however you like" per the plan's own wording. The app
// still needs a deterministic day-to-menu mapping (for the calendar/
// grocery-list pages), so this alternates Menu A/B across the 7 weekday
// slots (Mon/Wed/Fri/Sun = A, Tue/Thu/Sat = B) - swap a day's menu any time
// via the custom-menu feature if you want a different mix that day.
// Grams are as the plan states them: raw/dry weight for MillD atta and iD
// batter, cooked weight for rice - see the "Measuring guide" note surfaced
// in the UI. `ingredients` keys reference GROCERY_ITEMS in data/groceries.js
// and drive the pantry-deduction logic when a meal is checked off.
const ing = (key, qty) => ({ key, qty })

const MENU_A = {
  name: 'Idli + MillD Roti Day',
  meals: [
    {
      key: 'breakfast',
      time: '08:00',
      label: 'Breakfast',
      items: ['4 idlis (160g iD Protein batter, steamed)', 'Peanut chutney (15g roasted peanuts, garlic, green chilli, tempered)'],
      kcal: 368,
      protein: 28,
      ingredients: [ing('idBatter', 160), ing('peanuts', 15)],
    },
    {
      key: 'midMorning',
      time: '11:00',
      label: 'Mid-morning',
      items: ['100g high-protein Greek yogurt / skyr', '1 apple (150g)'],
      kcal: 143,
      protein: 11,
      ingredients: [ing('greekYogurt', 100), ing('apple', 1)],
    },
    {
      key: 'lunch',
      time: '13:30',
      label: 'Lunch',
      items: ['2 MillD rotis (67g MillD atta)', 'Paneer bhurji (100g high-protein paneer + onion-tomato + veg, 1 tsp oil)', 'Green salad (~150g: cucumber, tomato, onion, carrot, lemon)'],
      kcal: 569,
      protein: 53,
      ingredients: [ing('milldAtta', 67), ing('paneer', 100), ing('saladVeg', 150)],
    },
    {
      key: 'preWorkout',
      time: '17:30',
      label: 'Pre-workout',
      items: ['Whey (1 scoop in water)', 'Creatine 3-5g', '1 banana (100g)'],
      kcal: 209,
      protein: 25,
      ingredients: [ing('banana', 1)],
    },
    {
      key: 'postWorkout',
      time: '21:00',
      label: 'Post-workout + Dinner',
      items: ['Tofu sabzi (150g firm tofu + capsicum-onion, 1 tsp oil)', '120g cooked rice', 'Toned milk (250ml, before bed)'],
      kcal: 514,
      protein: 29,
      ingredients: [ing('tofu', 150), ing('rice', 120), ing('milk', 250)],
    },
  ],
}

const MENU_B = {
  name: 'Paneer Sandwich Day',
  meals: [
    {
      key: 'breakfast',
      time: '08:00',
      label: 'Breakfast',
      items: ['Grilled paneer bhurji sandwich - 4 slices high-protein bread (~130g)', 'Filling: 70g high-protein paneer + onion/tomato/capsicum', 'Mint-coriander green chutney', 'Toasted with 1 tsp oil'],
      kcal: 558,
      protein: 39,
      ingredients: [ing('highProteinBread', 130), ing('paneer', 70)],
    },
    {
      key: 'midMorning',
      time: '11:00',
      label: 'Mid-morning',
      items: ['100g high-protein Greek yogurt / skyr', '1 apple (150g)'],
      kcal: 143,
      protein: 11,
      ingredients: [ing('greekYogurt', 100), ing('apple', 1)],
    },
    {
      key: 'lunch',
      time: '13:30',
      label: 'Lunch',
      items: ['2 MillD rotis (67g MillD atta)', 'Tofu sabzi (130g firm tofu + capsicum-onion, 1 tsp oil)', 'Green salad (~150g: cucumber, tomato, onion, carrot, lemon)'],
      kcal: 515,
      protein: 49,
      ingredients: [ing('milldAtta', 67), ing('tofu', 130), ing('saladVeg', 150)],
    },
    {
      key: 'preWorkout',
      time: '17:30',
      label: 'Pre-workout',
      items: ['Whey (1 scoop in water)', 'Creatine 3-5g', '1 banana (100g)'],
      kcal: 209,
      protein: 25,
      ingredients: [ing('banana', 1)],
    },
    {
      key: 'postWorkout',
      time: '21:00',
      label: 'Post-workout + Dinner',
      items: ['Tofu curry (120g firm tofu in onion-tomato gravy, 1 tsp oil)', '100g cooked rice', 'Toned milk (250ml, before bed)'],
      kcal: 452,
      protein: 25,
      ingredients: [ing('tofu', 120), ing('rice', 100), ing('milk', 250)],
    },
  ],
}

// menuNumber 1-7 = Mon-Sun, alternating A/B/A/B/A/B/A across the week.
export const MENUS = {
  1: MENU_A,
  2: MENU_B,
  3: MENU_A,
  4: MENU_B,
  5: MENU_A,
  6: MENU_B,
  7: MENU_A,
}

// Overrides MENUS in place from a Firestore-sourced plan - see
// registerWorkoutLibrary in data/workouts.js for why this mutates rather
// than replaces the exported object.
export function registerMenuLibrary(menus) {
  Object.assign(MENUS, menus)
}

export function getMenu(menuNumber) {
  const menu = MENUS[menuNumber]
  return {
    number: menuNumber,
    name: menu.name,
    meals: menu.meals,
    totalKcal: menu.meals.reduce((s, m) => s + m.kcal, 0),
    totalProtein: menu.meals.reduce((s, m) => s + m.protein, 0),
  }
}
